export default __webpack_public_path__ + "static/media/105049.7e8283ec.jpg";